import { render, staticRenderFns } from "./OtherLegalDocs.vue?vue&type=template&id=dc4f1108&scoped=true"
import script from "./OtherLegalDocs.vue?vue&type=script&lang=js"
export * from "./OtherLegalDocs.vue?vue&type=script&lang=js"
import style0 from "./OtherLegalDocs.vue?vue&type=style&index=0&id=dc4f1108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4f1108",
  null
  
)

export default component.exports